module.exports = __webpack_public_path__ + "e07a77d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/clearbutton@2x.png
// module id = 1024
// module chunks = 0